@if (!isAppMobile) {
  <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
    {{ 'validation.sousTitre' | translate }}
  </h1>
}
<h2 id="titreValidationCourriel" tabindex="-1" class="dsd-t-3 dsd-mb-sm">
  {{ 'validation.titre' | translate }}
</h2>

<dsd-container>
  <p>
    <span class="libelle">{{ 'validation.libelleCourriel' | translate }}&nbsp;</span>
    <span class="valeur line-data">{{ courriel }}</span>
  </p>
  <dsd-button id="naviguerVersModifier" variant="compact" (dsdButtonClick)="naviguerVersModifier()">
    {{ 'bouton.modifier' | translate }}&nbsp;
    <span class="dsd-sr-only">
      {{ 'horsEcran.pageValidationCourriel' | translate }}
    </span>
  </dsd-button>
</dsd-container>

<div class="zone-btn">
  <!-- Bouton Confirmer -->
  <dsd-button variant="primary" full-width="xs" (dsdButtonClick)="naviguerVersConfirmation()">
    {{ 'bouton.confirmer' | translate }}
  </dsd-button>
  <!-- Bouton Annuler -->
  <dsd-button variant="secondary" full-width="xs" id="btnAnnuler" (dsdButtonClick)="annuler()">
    {{ 'bouton.annuler' | translate }}
  </dsd-button>
</div>
